export enum ColoredIconColorsEnum {
    SUCCESS = 'success',
    WARNING = 'warning',
    INFO = 'info',
    NEUTRAL = 'neutral',
}
